module.exports = __webpack_public_path__ + "img/Slice3.f410d667.png";